// Single source of truth for the amber "Needs configuration" pill
// (NeedsConfigPill). Every surface that renders the pill — ActiveBenefitRow,
// ModifyTypeModal plan rows, and both waived-row pages — must decide through
// resolveNeedsConfigReason so the same plan can't get different verdicts on
// the same page.

export type NeedsConfigReason = "contributions" | "coverage" | "both" | null;

export function resolveNeedsConfigReason(opts: {
  /** False while contribution/rate data is still loading. Never flag during
   * load — an empty default array is indistinguishable from "no rows". */
  loaded: boolean;
  /** FSA plans configure via annual election limits, not contribution rows —
   * zero contribution rows is their NORMAL state, never a gap. */
  isFsa: boolean;
  isLifeDisability: boolean;
  /** Contribution rows for this plan (after load). */
  contributionCount: number;
  /** Life/disability only — whether a coverage (benefit) amount resolved.
   * Pass null/undefined when unknown (no premium recompute available, e.g.
   * waived rows): unknown must NOT flag a gap. */
  coverageAmountResolved?: boolean | null;
}): NeedsConfigReason {
  if (!opts.loaded) return null;
  const contribGap = !opts.isFsa && opts.contributionCount === 0;
  const coverageGap = opts.isLifeDisability && opts.coverageAmountResolved === false;
  if (contribGap && coverageGap) return "both";
  if (contribGap) return "contributions";
  if (coverageGap) return "coverage";
  return null;
}
